import {
  Box,
  CircularProgress,
  DialogContent,
  DialogTitle,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import IconWrapper from "components/IconWrapper";
import close from "assets/images/close.svg";
import "./bidPopover.scss";
import { useEffect, useState } from "react";
import axios from "axios";
import { MoreHoriz } from "@mui/icons-material";
import { format } from "date-fns";
import { getUserToken } from "utils/functions/userToken";
import { APP_AI_CONNECT_API_ENDPOINT } from "constants/api_urls";

const BidPopover = ({ bid }) => {
  const token = getUserToken() || "";
  const bidHistoryURL = `${APP_AI_CONNECT_API_ENDPOINT}${bid?.bid_history_path}`;

  const [columns, setColumns] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [bidEditModal, setbidEditModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (bidEditModal) {
      setLoading(true);
      axios
        .get(bidHistoryURL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          const data = res?.data;
          setColumns(data?.columns_list);
          setTableData(data?.history_list);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [bid, bidEditModal, bidHistoryURL, token]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;
    return format(date, "dd/MM/yyyy - hh:mm a");
  };

  return (
    <>
      <span className="bid-cell-wrapper">
        <span
          className={"bid-cell"}
          onClick={(e) => {
            e.stopPropagation();
            setbidEditModal(true);
            setAnchorEl(e.currentTarget);
          }}
        >
          {bid?.bid_label || <MoreHoriz />}
        </span>
      </span>
      <Popover
        open={bidEditModal}
        anchorEl={anchorEl}
        onClose={() => {
          setbidEditModal(false);
        }}
        slotProps={{
          paper: {
            sx: {
              position: "relative",
              width: "400px",
              maxHeight: "400px",
              height: "fit-content",
              boxShadow: "0px 5px 8px 0px rgba(0, 0, 0, 0.25)",
              borderRadius: "10px",
              paddingBottom: "12px",
            },
          },
        }}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
      >
        <DialogTitle
          className="bid-popover-dialog-title"
        >
          <span className="dialogTitle">{bid?.bid_edit_in_place_title}</span>
          <span>
            <IconWrapper
              onClick={() => {
                setbidEditModal(false);
              }}
              icon={close}
            />
          </span>
        </DialogTitle>
        <DialogContent>
          <Table className="bid-table">
            <TableHead>
              <TableRow>
                {columns
                  ?.filter((c) => c?.column_id !== "status")
                  ?.map((col) => (
                    <TableCell key={col?.column_id} className="bid-table-header-cell">
                      {col?.column_label}
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={columns.length} className="bid-table-loading-cell">
                    <Box className="bid-table-loading-box">
                      <CircularProgress />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : tableData?.length ? (
                tableData?.slice(0, 8).map((item, rowIndex) => {
                  const row = item?.history_data;
                  return (
                    <TableRow key={rowIndex}>
                      {columns
                        ?.filter((c) => c?.column_id !== "status")
                        ?.map((col) => (
                          <TableCell
                            className="bid-table-body-cell"
                            key={col?.column_id}
                          >
                            {col?.column_type === "DATE"
                              ? formatDate(row?.[col.column_id])
                              : col?.column_type === "VALUE"
                              ? `${row?.[col.column_id]}`
                              : row?.[col.column_id]}
                          </TableCell>
                        ))}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={columns.length}>
                    <div className="bid-table-no-history">
                      No Bid History Available
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </DialogContent>
      </Popover>
    </>
  );
};
export default BidPopover;
